import { render, staticRenderFns } from "./alice.vue?vue&type=template&id=fa61dce0&scoped=true"
import script from "./alice.vue?vue&type=script&lang=js"
export * from "./alice.vue?vue&type=script&lang=js"
import style0 from "./alice.vue?vue&type=style&index=0&id=fa61dce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa61dce0",
  null
  
)

export default component.exports